module.exports = __webpack_public_path__ + "static/media/metr.f5032db4.jpg";